// utils/routeRoleMap.ts

import { menuItems } from "@/layouts/hydrogen/menu-items";

// import { menuItems } from '@/layout';

type RouteRoleMap = Record<string, string[]>;

export const buildRouteRoleMap = (): RouteRoleMap => {
  const map: RouteRoleMap = {};

  const processItem = (item: any) => {
    if (item.href && item.href !== '#') {
      map[item.href.split('?')[0]] = item.roles || [];
    }

    if (item.dropdownItems) {
      item.dropdownItems.forEach((child: any) => {
        if (child.href) {
          map[child.href.split('?')[0]] = item.roles || [];
        }
      });
    }
  };

  menuItems.forEach(processItem);

  return map;
};